import {ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-info-block',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ng-content></ng-content>
        <span *ngIf="closeButton" class="object-select-panel__remove" (click)="closed.emit()">
            <lib-icon type="cross"></lib-icon>
        </span>
    `,
    styles: [`
        :host {
            display: block;
            position: relative;
        }
    `]
})

export class InfoBlockComponent implements OnInit {
    @Input() type: 'attention' | 'warning' | 'info' | 'success' = 'warning';

    /**
     * Использовать 'плоский' дизайн?
     * @type {boolean}
     */
    @Input() flat = false;
    @Input() closeButton = false;

    @Output() closed = new EventEmitter();

    @HostBinding('class') private className = '';

    ngOnInit() {
        const baseCN = 'info-block';
        const additionalCN = 'select-panel-remove-container';

        const cssClasses = [additionalCN, baseCN, baseCN + '--' + this.type];

        if (this.flat) {
            cssClasses.push(`${baseCN}--flat`);
        }

        this.className = cssClasses.join(' ');
    }
}
